import { createFileRoute } from "@tanstack/react-router";
import { useRoleGuard } from "@/hooks/use-role-guard";
import { StaffShell } from "@/components/staff-shell";
import { ReferAndEarn } from "@/components/refer-and-earn";

export const Route = createFileRoute("/refer")({
  head: () => ({
    meta: [
      { title: "Refer and earn - DeckScore" },
      { name: "description", content: "Staff referral link and commission earnings for DeckScore." },
      { property: "og:title", content: "Refer and earn - DeckScore" },
      { property: "og:description", content: "Staff referral link and commission earnings for DeckScore." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ReferPage,
});

function ReferPage() {
  // Staff only. Non-staff are sent to /dashboard, which already routes
  // founders to their dashboard and investors to /investor.
  const { status } = useRoleGuard(["admin", "super_admin"]);
  if (status !== "ok") {
    return (
      <div className="min-h-screen bg-bg grid place-items-center text-ink-secondary">
        Loading...
      </div>
    );
  }
  return (
    <StaffShell>
      <ReferAndEarn />
    </StaffShell>
  );
}
